import { render, staticRenderFns } from "./profileIncrease.vue?vue&type=template&id=784abf84&"
import script from "./profileIncrease.vue?vue&type=script&lang=js&"
export * from "./profileIncrease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports